import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { TooltipDirective } from '@core/directives/tooltip.directive';
import { LoadingIconComponent } from '@core/components/loading-icon/loading-icon.component';
import { PricingItem, PricingHistoryEntry } from '../../prices.interface';
import { PricesService } from '../../prices.service';

@Component({
  selector: 'app-price-history-modal',
  standalone: true,
  imports: [DatePipe, CurrencyPipe, DecimalPipe, TooltipDirective, SvgIconComponent, LoadingIconComponent],
  templateUrl: './price-history-modal.component.html',
  styleUrl: './price-history-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class PriceHistoryModalComponent {
  private readonly pricesService = inject(PricesService);

  item = input<PricingItem>();

  itemName = computed(() => this.item()?.name ?? 'Unknown Item');

  isLoading = signal(true);
  history = signal<PricingHistoryEntry[]>([]);

  constructor() {
    effect(() => {
      const item = this.item();
      if (item) {
        this.fetchHistory(item.id);
      }
    });
  }

  private async fetchHistory(_skinid: number): Promise<void> {
    this.isLoading.set(true);
    try {
      // TODO: wire ap_get_price_history socket call
      this.history.set([]);
    } finally {
      this.isLoading.set(false);
    }
  }

  getChangePercent(entry: PricingHistoryEntry): number {
    if (!entry.previous_price || entry.previous_price === 0) return 0;
    return Math.abs(
      ((entry.price - entry.previous_price) / entry.previous_price) * 100
    );
  }

  getChangeIcon(entry: PricingHistoryEntry): string {
    return entry.price >= entry.previous_price
      ? 'assets/icons/shared/arrow-up.svg'
      : 'assets/icons/shared/arrow-down.svg';
  }

  getChangeClass(entry: PricingHistoryEntry): string {
    return entry.price >= entry.previous_price ? 'up' : 'down';
  }
}
